import React from 'react';
import BzmIcon from './BzmIcon';
import clsx from 'clsx';
import { TransactionType } from '../../types/rest/assetCatalogTypes';

interface Props {
  type: TransactionType;
  className?: string;
}

interface VirtualServiceTypeDict {
  name: string;
  icon: string;
}

const dict: {
  [key in TransactionType]: VirtualServiceTypeDict;
} = {
  HTTP: { name: 'HTTP Transaction', icon: 'icon-bzm-http' },
  MESSAGING: { name: 'Messaging Transaction', icon: 'icon-bzm-stacked-email' },
};

const VirtualServiceTypeIcon = ({ type, className }: Props) => {
  return <BzmIcon title={dict[type].name} variant={dict[type].icon} className={clsx('icon-xs', className)} />;
};

export default VirtualServiceTypeIcon;
